<article
  class="selection-card"
  [class.active]="active"
  [class.disabled]="disabled"
  (click)="onClick()">

  <!-- Image cachée uniquement pour déclencher l'événement (load) -->
  <img style="display: none" [src]="imgSrc" [alt]="label" (load)="onImageLoad()" />

  @if (imageLoaded) {
    <div class="selection-card-img" [style.background-image]="'url(' + imgSrc + ')'"></div>
  } @else {
    <div class="selection-card-img selection-card-img-loading">
      <ng-casto-loader></ng-casto-loader>
    </div>
  }

  <p class="selection-card-label">{{ label }}</p>
</article>
